import React from 'react';
import { withRouter } from 'react-router';
import { bool, shape, object, string, array } from 'prop-types';
import useMedia from '../../Hooks/useMedia';
import queryString from 'qs';
import classNames from 'classnames';
import { OpenModalButton } from '../../Modal';
import FullscreenModal from '../../Modal/fullscreen-modal';
import * as utils from './helpers';
import Map from './map2';

const FindCareMap = (props) => {
  const qs = queryString.parse(props.location.search, {
    ignoreQueryPrefix: true,
  });

  if (!utils.shouldDisplayMap(qs, props.SearchResult)) {
    return null;
  }

  const isMediumOrLarger = useMedia(
    ['print, screen and (min-width: 40em)'],
    [true],
    false
  );

  return (
    <div
      className={classNames({
        'findcare-map': true,
        'findcare-map--is-loading': props.SearchResult.isLoading,
      })}
    >
      {/* <Small devices only> */}
      <OpenModalButton
        className="findcare-map__map-modal-trigger"
        id="searchmap-small"
      >
        {props.Translations.showhitsonmap}
      </OpenModalButton>
      <FullscreenModal
        hideWithCss={false}
        id="searchmap-small"
        classModifier="findcare-fullscreen"
      >
        <Map
          {...props}
          modifiers={{ 'findcare-map__gmap--modal': true }}
          expand={false}
        />
      </FullscreenModal>
      {/* </Small devices only> */}
      {isMediumOrLarger && (
        <div className="findcare-map__container">
          <Map {...props} />
        </div>
      )}
    </div>
  );
};

FindCareMap.propTypes = {
  SearchResult: shape({
    SearchHits: array,
    isLoading: bool,
  }),
  Translations: shape({
    showhitsonmap: string,
  }),
  /** From react-router withRouter() higher order component */
  location: object,
};

export default withRouter(FindCareMap);
